import React from 'react';

const Loader = ({ fullScreen = true }) => {
  return (
    <div className={`flex flex-col justify-center items-center ${fullScreen ? 'fixed inset-0 bg-white bg-opacity-90 z-[9999]' : 'p-12'}`}>
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
      <p className="mt-4 text-gray-600 text-lg">Loading...</p>
    </div>
  );
};

export default Loader;
